import React from "react";
import { Link } from "react-router-dom";
import { Star, Plus } from "lucide-react";
import { useCart } from "../context/CartContext";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const onSale = product.compareAt && product.compareAt > product.price;

  return (
    <div className="card-hover group flex flex-col overflow-hidden rounded-2xl border-2 border-[#95D5B2] bg-white shadow-sm transition-colors hover:border-[#2D6A4F]" data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="relative block">
        <div className="relative aspect-square overflow-hidden bg-white">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-contain p-4 transition duration-500 group-hover:scale-105"
          />
          {product.badge && (
            <span
              className={`absolute left-3 top-3 rounded-full px-3 py-1 font-display text-[11px] font-semibold uppercase tracking-wider text-white ${
                product.badge === "Sale" ? "bg-[#c1121f]" : product.badge === "New" ? "bg-[#2D6A4F]" : "bg-[#1B4332]"
              }`}
            >
              {product.badge}
            </span>
          )}
        </div>
      </Link>

      <div className="flex flex-1 flex-col bg-[#1B4332] p-4" data-testid="product-card-info">
        <div className="mb-1 flex items-center gap-1 text-[#95D5B2]">
          <Star size={13} className="fill-current" />
          <span className="text-xs font-semibold text-white">{product.rating}</span>
          <span className="text-xs text-[#B7E4C7]">({product.reviews})</span>
        </div>
        <Link to={`/product/${product.slug}`}>
          <h3 className="mb-2 line-clamp-2 min-h-[40px] font-display text-[15px] font-semibold uppercase leading-tight text-white transition group-hover:text-[#B7E4C7]">
            {product.short || product.name}
          </h3>
        </Link>

        {product.bundleItems && (
          <p className="mb-2 line-clamp-1 text-xs text-[#B7E4C7]">{product.bundleItems.join(" + ")}</p>
        )}

        <div className="mt-auto flex items-center justify-between gap-2 pt-2">
          <div className="flex min-w-0 flex-wrap items-baseline gap-x-2">
            <span className="font-display text-base font-bold text-white sm:text-lg">£{product.price.toFixed(2)}</span>
            {onSale && <span className="text-xs text-[#95D5B2] line-through sm:text-sm">£{product.compareAt.toFixed(2)}</span>}
          </div>
          <button
            onClick={() => addItem(product)}
            aria-label="Add to cart"
            data-testid={`add-to-cart-${product.slug}`}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-[#1B4332] transition-colors hover:bg-[#B7E4C7] active:scale-90"
          >
            <Plus size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
